import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var FormAlert = function FormAlert(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return (// There are currently no associated styles with the pf-c-form_alert class.
    // Therefore, it does not exist in react-styles
    React.createElement("div", Object.assign({}, props, {
      className: css('pf-c-form__alert', className)
    }), children)
  );
};
FormAlert.displayName = 'FormAlert';